import { CustomField } from "@/backend/models/customFields/customField";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { Parameter } from "@/backend/models/parameter";
import { Select } from "../Select";
import { ChoiceLabelAndValue } from "./ChoiceLabelAndValue";

export function SingleChoiceParameterSelect(props: { parameter: Parameter, disabled?: boolean }) {
  const { parameter, disabled } = props;
  const selectedField = parameter.fields.find((field) => field.isSelected);
  const selectField = useParameterStore((state) => state.selectField);

  const selectValue = (field: CustomField) => {
    void selectField({ parameterId: parameter.id, selectedFieldId: field.id });
  };

  const label = selectedField?.getLabel();

  return (
    <Select label={parameter.title} value={label || I18n.get('selectDot')} minWidth='400px' disabled={disabled}>
      { parameter.fields.map((field) => (
        <button type="button" key={field.id} className="w-100 dropdown-item" onClick={() => selectValue(field)}>
          <ChoiceLabelAndValue field={field} />
        </button>
      ))}
    </Select>
  );
}
